import { ReactNode } from 'react';
import { EventRate, IconTooltip } from 'common--design-library';
import { IDetailDW, IDetailBase } from 'desktop--design-library';
import { IOdd } from 'eTip--common';
import React from 'react';
import { LiveEventOdds } from './eventOdds';

export interface ILiveEventGameProps {
    id: string;
    name: string;
    infoIcon?: ReactNode | null;
    hasDetails: boolean;
    details: IDetailDW[];
    isOpen: boolean;
    isActive: (oddKey: string) => boolean;
    isInActive: (oddKey: string) => boolean;
    onClick?: (detail: IDetailBase, odd: IOdd) => void;
    toggleOpen: () => void;
    gameInfo: string | null;
}

/**
 * Component to render group of games. Use as simple function, not component since then there is a real problem with isActive (does not work).
 */
export function renderLiveEventGame(key: string, props: ILiveEventGameProps) {
    return <div className="game" key={key}>
        <div className="game-name d-flex align-items-center p-2" style={{ cursor: "pointer" }} onClick={(e) => { e.stopPropagation(); props.toggleOpen(); }}>
            <div style={{ float: "left" }}>
                <span className={`${props.isOpen ? "fa fa-caret-up" : "fa fa-caret-down"} mr-1`}></span>
            </div>
            {props.name}
            {props.infoIcon}
            {
                props.gameInfo?.length > 0 &&
                <IconTooltip targetid={`live_detail_iconinfo_${props.id}`} allowOnTouchScreen placement="right" target={
                    <span id={`live_detail_iconinfo_${props.id}`} className="etip-info ml-1" />
                }>
                    {props.gameInfo}
                </IconTooltip>
            }
        </div>
        {props.isOpen &&
            <div>
                {props.details.map((detail) => {
                    return <LiveEventOdds
                        detail={detail}
                        gameHasDetails={props.hasDetails}
                        key={detail.id}
                    >
                        {
                            detail.odds.map((odd) => {
                                return <EventRate
                                    {...odd}
                                    oddKey={odd.key}
                                    className="flex-grow-1 mr-1 mt-1"
                                    active={props.isActive(odd.key)}
                                    inactive={props.isInActive(odd.key)}
                                    onClick={() => { props.onClick && props.onClick(detail, odd); }}
                                    showTipsInside={true}
                                    roleForTest="rate"
                                    tooltipIdPrefix='liveEventDetail'
                                />
                            })
                        }
                    </LiveEventOdds>
                })}
            </div>
        }
    </div>
};